export const SettingsActionType = Object.freeze({
  SET_TAB: "Settings:: Set settings tab",
  SET_PROFILE: "Profile:: Set About me",
  SET_OPEN_PWD_DIALOG: "Account:: Open password change dialog",
  SET_OPEN_DEACT_DIALOG: "Account:: Open confirmation dialog",
  SET_PWD_DIALOG_CONTENT: "Account:: Set password dialog content",
});

export const SettingsTabs = Object.freeze({
  PROFILE: "PROFILE",
  NOTIFICATION: "NOTIFICATION",
  ACCOUNT: "ACCOUNT",
  DISPLAY: "DISPLAY",
});
